module.exports = __webpack_public_path__ + "static/media/tn.da3fd8d1.jpg";